<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<section *ngIf="swiperSliders?.length">
  <swiper-container #swiper init="false" class="swiper-container">
    <swiper-slide
      *ngFor="let slide of swiperSliders; let i=index"
      class="slider-banner"
    >
      <img [src]="slide" />     
    </swiper-slide>
  </swiper-container>
  <div class="swiper-pagination"></div>
  <button *ngIf="controls" class="swiper-button-prev slide-control prev" ion-button>
    <ion-icon name="chevron-back-outline"></ion-icon>
  </button>
  <button *ngIf="controls" class="swiper-button-next slide-control next" ion-button>
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </button>
</section>
